import * as actionTypes from 'redux/actions'

const initialState = {
  campaign: null
}

const renewCampaignReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_RENEW_CAMPAIGN: {
      return {
        ...state,
        campaign: action.payload
      }
    }

    default:
      return state
  }
}

export default renewCampaignReducer
